module.exports = __webpack_public_path__ + "img/rh.19668391.png";